import { InputTag } from 'mixs/base/input_mixin';

class Hidden extends InputTag {
  init(){
    super.init();
    this.watch();
  }
}

riot.mixin("inputs.hidden", Hidden as riot.TagMixin)
